export interface MetaDataType {
  current_page: number;
  last_page: number;
  page_size: number;
  total: number;
}

export interface SearchDetailContent {
  data: any[];
  meta: MetaDataType;
}

export interface SearchProps {
  posts: SearchDetailContent;
  accounts: SearchDetailContent;
  news_feed: SearchDetailContent;
}

export const SearchPropsDummy = {
  posts: {
    data: [],
    meta: {
      current_page: 1,
      last_page: 1,
      page_size: 10,
      total: 0,
    },
  },
  accounts: {
    data: [],
    meta: {
      current_page: 1,
      last_page: 1,
      page_size: 10,
      total: 0,
    },
  },
  news_feed: {
    data: [],
    meta: {
      current_page: 1,
      last_page: 1,
      page_size: 10,
      total: 0,
    },
  },
};

export interface SearchPostProps {
  data: {
    author: string;
    author_id: number;
    category: string;
    context: string;
    created_at: string;
    id: number;
    media: any[];
    post_type: string;
    title: string;
  }[];
  meta: {
    current_page: number;
    last_page: number;
    page_size: number;
    total: number;
  };
}

export interface MetaResult {
  total: number;
  current_page: number;
  last_page: number;
  page_size: number;
}


export interface SearchResultPropsData {
  data: any[];
  meta: MetaResult;
}

export const dummySearchResultPropsData = {
  data: [],
  meta: {
    total: 0,
    current_page: 1,
    last_page: 1,
    page_size: 10,
  },
};
